import { useContext } from 'react';
import PropTypes from 'prop-types';
import i18nContext from 'components/i18n-context';
import { TWO_FACTOR_AUTH_TYPES } from 'components/common/constants';
import { ROUTE_PATHS } from 'routes/constants';
import { clearLocalStorage } from 'services/authUtils';

export const AuthorizationBackButton = ({ type, confirmationType, isGoogle2FAAuth = false }) => {
  const i18n = useContext(i18nContext);

  const backToLoginPage = () => {
    clearLocalStorage();
  };

  return (
    <>
      {type === 'register' ? (
        <div className={'back-button unset'}>
          <p>
            {i18n.getMessage('login.label.noAccount')}
            <a href={ROUTE_PATHS.REGISTRATION} className={'link-normal'}>
              {i18n.getMessage('login.link.register')}
            </a>
          </p>
        </div>
      ) : confirmationType === TWO_FACTOR_AUTH_TYPES.SMS && isGoogle2FAAuth ? (
        <div className={'back-button unset flex-column'}>
          <p>
            {i18n.getMessage('pin.returnToLogIn')}
            <a href={ROUTE_PATHS.LOGIN} className={'link-normal'} onClick={backToLoginPage}>
              {i18n.getMessage('login.returnToLogIn')}
            </a>
          </p>
        </div>
      ) : (
        <div className={'back-button unset flex-column'}>
          <p>
            {i18n.getMessage('pin.returnToLogIn')}
            <a href={ROUTE_PATHS.LOGIN} className={'link-normal'} onClick={backToLoginPage}>
              {i18n.getMessage('login.returnToLogIn')}
            </a>
          </p>
        </div>
      )}
    </>
  );
};

AuthorizationBackButton.propTypes = {
  type: PropTypes.string,
  isGoogle2FAAuth: PropTypes.bool,
  confirmationType: PropTypes.string
};
